import { MutationTree } from 'vuex'
import { IRecurly } from '@/@types'

const mutations: MutationTree<IRecurly> = {
  RECURLY_INSTANCE_UPDATED: state => {
    state.recurlyPricing = window.recurly.Pricing.Checkout()
  },
  RECURLY_PRICING_UPDATED: (state, recurlyPricing: object) => {
    state.recurlyPricing = recurlyPricing
  },
  RECURLY_PRODUCT_RECURLY_ITEM_UPDATED: (
    state,
    productRecurlyItem: any // TODO: Define type
  ) => {
    productRecurlyItem.recurlyItem = productRecurlyItem.value
  },
  RECURLY_TOKEN_UPDATED: (state, token: string) => {
    state.recurlyToken = token
  },
  RECURLY_ACTION_TOKEN_ID_UPDATED: (state, token: string) => {
    state.recurlyTokenActionId = token
  },
  RECURLY_ACTION_TOKEN_RESULT_UPDATED: (state, token: string) => {
    state.recurlyTokenActionResult = token
  },
}

export default mutations
